import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      var href = anchor.getAttribute('href');
      if (href != '#')
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          document.querySelector(href).scrollIntoView({
            behavior: 'smooth',
          });
        });
    });
  }
}
